export const handleEmailExtraction = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const emailContent = e.target.result;
      const parsedData = parseEmailContent(emailContent);
      resolve(parsedData);
    };
    reader.onerror = reject;
    reader.readAsText(file);
  });
};

const parseEmailContent = (emailContent) => {
  const htmlPartMatch = emailContent.match(/Content-Type: text\/html[\s\S]*?<body[\s\S]*?<\/body>/i);
  console.log('htmlPartMatch', htmlPartMatch);

  if (!htmlPartMatch) {
    console.error("HTML content not found in email");
    return [];
  }

  let htmlContent = htmlPartMatch[0];
  
  // Decode the HTML content
  htmlContent = htmlContent.replace(/=\r\n/g, '');
  htmlContent = htmlContent.replace(/=([0-9A-F]{2})/g, (_, p1) => 
    String.fromCharCode(parseInt(p1, 16))
  );

  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(htmlContent, "text/html");
  
  // Find the table that contains the transaction data
  const targetTable = htmlDoc.querySelector("table.reports");

  if (!targetTable) {
    console.error("Transaction table not found in email content");
    return [];
  }

  const rows = targetTable.querySelectorAll("tbody > tr");
  const parsedData = [];

  rows.forEach((row) => {
    const cells = row.querySelectorAll("td");
    if (cells.length < 11) return; // Skip rows that don't have enough cells

    const rowData = {
      Id: '',
      Balance: '',
      Amount: '',
      Currency: 'GBP',
      Type: 'TRADE',
      Status: 'PROCESSED',
      Modified: '',
      'Trade Id': '',
      'Instrument Symbol': '',
      'Instrument Name': '',
      Commission: '',
      'Account type': 'Trading212'
    };

    cells.forEach((cell, cellIndex) => {
      let content = cell.textContent.replace(/\s+/g, " ").trim();

      switch (cellIndex) {
        case 0: 
          rowData.Id = content;
          rowData['Trade Id'] = content;
          break;
        case 1:
          rowData.Type = content;
          break;
        case 9:
          rowData.Amount = content;
          break;
        case 3:
          rowData['Instrument Symbol'] = content;
          rowData['Instrument Name'] = content;
          break;
        case 4:
          rowData.Currency = content;
          break;
        case 6:
          rowData.Modified = content;
          break;
        // case 8:
        //   rowData.Balance = content;
        //   break;
        case 10:
          rowData.Currency = content;
          break;
      }
    });

    if (rowData.Id && rowData.Id.startsWith('POS')) {
      parsedData.push(rowData);
    }
  });

  return parsedData;
};